module.exports = {
      id: "light-75(1s) index-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#light-75(1s) index-usage",
      toString: function () {
        return this.url;
      }
    }